import { useState, useEffect } from 'react'
import Layout from '../components/common/Layout'
import {
  makeStyles,
  Container,
  Paper,
  FormControlLabel,
  Checkbox,
  Box,
} from '@material-ui/core'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import ButtonSp from '../components/ui/ButtonSp'
import Axios from 'axios'
import useSnackBar from '../components/ui/useSnackBar'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    width: '100vw',
    flexGrow: 1,
    padding: '20px 0',
  },
  paper: {
    width: '100%',
    maxHeight: '50vh',
    overflow: 'scroll',
    padding: 20,
    '& > :not(h1)': {
      fontFamily: 'Helvetica, sans-serif',
    },
    '& > h1': {
      color: theme.palette.primary.main,
      textAlign: 'center',
    },
  },
  button: {
    ...theme.homeStyle.button,
    marginTop: theme.spacing(2),
  },
}))

const termsAndPrivacyXML = (
  <section>
    <h2 class="heading">เงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัว</h2>
    <div class="wrapper-1000 wrapper-terms-privacy">
      <h2>เงื่อนไขการใช้บริการ (Terms of Use)</h2>
      <div class="article-page text-left">
        <div class="article-wrapper">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บริษัท
            ชิปป๊อป จำกัด เราคือพันธมิตรที่รวบรวมบริษัทขนส่ง มาไว้ในระบบเดียว
            ง่ายต่อการเชื่อมต่อและเลือกใช้บริการที่หลากหลาย
            โดยเฉพาะคนขายของออนไลน์
            โปรดอ่านเงื่อนไขการใช้บริการโดยละเอียดเพื่อประโยชน์ในการรับบริการจากเรา
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การตกลงสมัครเข้าใช้บริการ
            ถือว่าผู้ใช้บริการยอมรับว่าได้อ่านและทำความเข้าใจเงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวโดยละเอียดถี่ถ้วนแล้ว
            และผู้ใช้บริการยอมรับเงื่อนไขการใช้บริการทุกประการและนโยบายความเป็นส่วนตัว
            เงื่อนไขการใช้บริการฉบับนี้มีผลผูกพันผู้ใช้บริการตามกฏหมาย
          </p>
          <p>&nbsp;</p>
          <p>
            1. เงื่อนไขการใช้บริการของบริษัท ชิปป๊อป จำกัด
            ฉบับนี้มีวัตถุประสงค์เพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฎหมายอันพึ่งต้องปฎิบัติตาม
          </p>
          <p>2. คำจำกัดความ</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1
            &ldquo;ผู้ให้บริการ&rdquo; หมายถึง บริษัท ชิปป๊อป จำกัด ในชื่อของ
            &ldquo;เว็บไซต์ SHIPPOP&rdquo; หรือชื่ออื่นใดอันหมายถึงบริการนี้ และ
            ให้หมายรวมถึงการงานใช้ส่วนใดส่วนหนึ่งหรือทั้งหมด ทั้ง
            โดยตรงผ่านเว็บไซต์และหรือผ่านตัวแทนในรูปแบบต่างๆ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.2
            &ldquo;ผู้ใช้บริการ&rdquo; หมายถึง บุคคลใดก็ตามที่เข้าถึง เข้า
            ใช้งาน ไม่ว่าจะเป็น ผลิตภัณฑ์ ซอฟต์แวร์ บริการ หรือเว็บไซต์
            ของผู้ให้บริการ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3
            &ldquo;เงื่อนไขการใช้บริการ&rdquo; หมายถึง ข้อตกลง ข้อกำหนด ข้อสัญญา
            หรือชื่ออื่นใดที่มีลักษณะแบบเดียวกัน
            เพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฎหมาย
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.4
            &ldquo;การให้บริการ&rdquo; หมายถึง
            การให้บริการระบบขนส่งหลากหลายบริษัทที่รวบรวมมาไว้ในระบบเดียว
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.5
            &ldquo;ข้อมูล&rdquo; หมายถึง
            ข้อมูลใดๆที่ผู้ใช้บริการหรือผู้ที่ได้รับมอบอำนาจจากผู้ใช้บริการให้ทำการแทนได้ให้ไว้แก่ทางเว็บไซต์
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.6
            &ldquo;ข้อมูลลับ&rdquo; หมายถึง
            ข้อมูลต่างๆที่คู่สัญญาได้ให้ไว้แก่กัน ไม่ว่าจะโดยทางวาจา,
            ลายลักษณ์อักษร หรือข้อมูลอิเลคทรอนิคส์
            แต่ไม่รวมถึงข้อมูลใดๆที่ได้ถูกเผยแพร่สู่สาธารณชนเป็นที่เรียบร้อยแล้ว
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.7
            &ldquo;ค่าบริการ&rdquo; หมายถึง
            ค่าบริการขนส่งที่ผู้ใช้บริการตกลงยินยอมตามที่ผู้ให้บริการเรียกเก็บ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.8
            &ldquo;ตัวแทน&rdquo; หมายถึง บุคคลและหรือนิติบุคคลใดก็ตาม
            หรือชื่ออื่นใดอันมีความหมายเดียวกัน
            ที่ได้รับอนุญาติและหรือได้รับแต่งตั้งให้สามารถนำระบบทั้งหมดหรือบางส่วนไปใช้ของ
            SHIPPOP
          </p>
          <p>
            3. การใช้บริการของผู้ให้บริการนั้น
            ผู้ใช้บริการต้องเข้าใจและยอมรับข้อตกลง เงื่อนไขการใช้บริการ
            และนโยบายความเป็นส่วนตัวต่างๆของผู้ให้บริการทั้งหมดก่อน
          </p>
          <p>
            4. การสมัครเข้าใช้บริการ การยอมรับข้อตกลง เงื่อนไขการใช้บริการ
            และนโยบายความเป็นส่วนตัวต่างๆ ถือว่าผู้ใช้บริการยอมรับได้ว่า
            อ่านและเข้าใจพร้อมทั้งตกลงยินยอมตามข้อตกลง เงื่อนไขการใช้บริการ
            นโยบายความเป็นส่วนตัวและหรือข้อบังคับอื่นใดแล้วแต่กรณี
          </p>
          <p>5. ผู้ให้บริการขอสงวนสิทธิ์ไม่ให้บริการขนส่งดังต่อไปนี้</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.1
            สัตว์มีชีวิต
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.2
            สิ่งเสพติด
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.3
            สิ่งลามกอนาจาร หรือสิ่งที่มีถ้อยคำ เครื่องหมาย ลวดลาย หยาบช้า
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.4
            วัตถุไวไฟ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.5
            วัตถุมีคมที่ไม่มีเครื่องหุ้มห่อ ป้องกัน
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.6
            สิ่งโสโครกหรือสิ่งมีพิษ อาจทำให้เกิดอันตรายแก่เจ้าพนักงาน
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.7
            สิ่งของปลอมแปลงหรือลอกเลียนแบบโดยละเมิดลิขสิทธิ์
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.8
            สิ่งอื่นใดอันผิดกฎหมาย หรือขัดต่อศีลธรรมอันดีของประชาชนชาวไทย
            หรือที่สร้างความเสื่อมเสีย หรือทำลายความมั่นคง ต่อประเทศชาติ ศาสนา
            และ สถาบันพระมหากษัตริย์
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การขอสงวนสิทธิ์ไม่ให้บริการขนส่ง
            นอกเหนือจากข้างต้นนั้น ผู้ให้บริการจะแจ้งให้ทราบเพิ่มเติมทางเว็บไซต์
            โดยมิต้องแจ้งให้ทราบล่วงหน้า
          </p>
          <p>
            6.
            ผู้ใช้บริการต้องให้ข้อมูลที่ถูกต้องและเป็นจริงทุกประการแก่ผู้ให้บริการ
            เพื่อประโยชน์ในการให้บริการขนส่งในบางกรณีผู้ให้บริการ
            อาจร้องขอเอกสารเพิ่มเติมเพื่อยืนยันข้อมูลต่างๆและผู้ใช้บริการยอมรับที่ต้องปฎิบัติตามคำร้องขอ
          </p>
          <p>
            7. ผู้ให้บริการไม่อนุญาติให้นำเข้าและหรือส่งออกซึ่งข้อมูลใดๆ และ
            หรือเอกสารใดๆเข้ามาในเวบไซด์โดยประการที่อาจทำให้เกิดความเสียหายแก่อุปกรณ์
            ฮาร์ดแวร์ หรือ ซอฟท์แวร์ อันเป็นความผิดตามกฎหมาย
          </p>
          <p>
            8.
            ผู้ใช้บริการต้องไม่พยายามหรือกระทำการใดๆที่เป็นอันตรายต่อความปลอดภัยของระบบคอมพิวเตอร์หรือระบบเน็ตเวิร์ค
            ซึ่งหมายรวมถึงการกระทำผิดใดๆตามที่กฎหมายกำหนด
          </p>
          <p>
            9.
            หากผู้ใช้บริการกำหนดให้บุคคลภายนอกซึ่งไม่ได้มีส่วนร่วมในการดูแลจัดการบัญชีของท่าน
            ผู้ให้บริการจะถือว่าการปฏิบัติของบุคคลภายนอกดังกล่าวคือการปฏิบัติของผู้ใช้บริการ
            หากการปฏิบัติของบุคคลดังกล่าวก่อให้เกิดความเสียหายหรือการเสียผลประโยชน์แก่ท่าน
            ผู้ให้บริการจะไม่รับผิดชอบใดๆทั้งสิ้น
          </p>
          <p>
            10.
            ผู้ให้บริการไม่อนุญาติให้ผู้ใช้บริการโอนสิทธิและหน้าที่ภายใต้ข้อตกลง
            เงื่อนไขการใช้บริการ
            และนโยบายความเป็นส่วนตัวแก่บุคคลและหรือนิติบุคคลอื่น โดยเด็ดขาด
          </p>
          <p>
            11. ข้อมูลส่วนบุคคลของผู้ใช้บริการ
            จะไม่เปิดเผยความลับหรือข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอกหรือองค์กรอื่นใดไม่ว่าเพื่อวัตถุประสงค์ใดๆ
            เว้นแต่
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.1
            ได้รับความยินยอมจากผู้ใช้บริการ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.2
            กระทำการตามที่กฎหมายบังคับ และหรือตามคำสั่งหรือหมายของศาล เป็นต้น
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.3
            เป็นไปตาม นโยบายความเป็นส่วนตัว
          </p>
          <p>
            12. ผู้ให้บริการ มีซึ่งสิทธิ ลิขสิทธิ์ และ
            ทรัพย์สินทางปัญญาในข้อมูลที่แสดง รูปภาพ และ รูปแบบการแสดงผล
            ตามที่ปรากฏในเว็บไซต์ทั้งหมด ยกเว้นจะมีการระบุอย่างชัดเจนเป็นอื่น
            ห้ามมิให้ผู้ใดทำการคัดลอก ทำซ้ำ มีสำเนา สำรองไว้ ทำเลียนแบบ ทำเหมือน
            ดัดแปลง ทำเพิ่ม เพื่อนำไปเผยแพร่ด้วยวัตถุประสงค์อื่นใด
            โดยปราศจากความยินยอมเป็นหนังสือจากผู้ให้บริการ
            ทั้งนี้เว้นแต่จะได้มีการระบุกำหนดไว้ในข้อตกลง เงื่อนไขการใช้บริการ
            และนโยบายความเป็นส่วนตัว
          </p>
          <p>
            13. ผู้ให้บริการ
            สามารถนำข้อมูลใดๆก็ตามที่ผู้ใช้บริการให้กับผู้ให้บริการ โดยผ่าน
            SHIPPOP ไปใช้ในการวิจัย วิเคราะห์ แยกแยะ และหรืออื่นใด
            ตามที่เห็นสมควร โดยมิต้องแจ้งให้ทราบล่วงหน้า
            ต้องเป็นข้อมูลที่ผู้ใช้บริการยินยอมให้ใช้ตามข้อตกลง
            เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว
          </p>
          <p>
            14. ผู้ให้บริการ
            ขอสงวนสิทธิ์ในการคืนค่าบริการในกรณีที่ผู้ใช้ต้องการยกเลิกใช้บริการ
            หรือปรับลดบริการลง ก่อนครบกำหนดสัญญา
            และผู้ใช้บริการไม่มีสิทธิ์เรียกค่าบริการคืน ไม่ว่าบางส่วน
            หรือทั้งหมดได้ เว้นแต่ทางผู้ให้บริการจะเป็นผู้ยกเลิกบริการเอง
            โดยจะคืนค่าบริการตามสมควรให้เท่านั้น
            หากมีการละเมิดข้อตกลงดังกล่าวผู้ให้บริการจะแจ้งเตือน
            และจะหยุดให้บริการหากผู้ใช้บริการไม่ทำการแก้ไขให้ถูกต้อง
            และผู้ใช้บริการจะไม่สามารถเรียกร้องสิทธิ์ในการคืนเงินได้
            และหากเป็นการกระทำที่ส่งผลกระทบต่อ ระบบ เครือข่าย
            และชื่อเสียงของผู้ให้บริการ
            ผู้ใช้บริการจะต้องรับผิดชอบความเสียหายที่เกิดขึ้นทั้งหมด กรณี
            ผู้ใช้บริการเกิดปัญหาในการใช้งาน
            ผู้ใช้บริการสามารถติดต่อผู้ให้บริการทาง email : cs@shippop.com
          </p>
          <p>
            15. ผู้ให้บริการ สามารถระงับการใช้บริการแก่ผู้ใช้บริการใดๆ
            ตามเห็นสมควรได้ ถึงแม้ว่าผู้ใช้บริการจะไม่ได้ละเมิดข้อตกลง
            เงื่อนไขการใช้การบริการ และนโยบายความเป็นส่วนตัวใดๆก็ตาม
            โดยผู้ให้บริการจะคืนค่าบริการตามจริงเฉพาะที่ยังไม่ได้ใช้งานเท่านั้น
            ทั้งนี้งให้เป็นไปตามเงื่อนไขของค่าบริการที่ผู้ให้บริการกำหนดไว้
            และผู้ใช้บริการไม่สามารถเรียกร้องค่าเสียหายอื่น ๆ
            นอกเหนือจากค่าบริการที่ผู้ใช้บริการได้ชำระกับผู้ให้บริการแล้วเท่านั้น
          </p>
          <p>
            16. ผู้ให้บริการ
            สามารถระงับการใช้บริการแก่ผู้ใช้บริการในกรณีที่ผู้ใช้บริการไม่เข้าสู่ระบบเป็นเวลานาน
            ซึ่งผู้ให้บริการขอสงวนสิทธิ์การระงับบริการโดยมิต้องแจ้งให้ทราบล่วงหน้า
          </p>
          <p>
            17. ผู้ให้บริการ อาจระงับการให้บริการเป็นการชั่วคราว
            ด้วยเหตุจำเป็นบางประการ
            และในกรณีที่มีการระงับบริการประเภทที่มีค่าบริการ
            ขอสงวนสิทธิในการไม่คืนค่าบริการสำหรับระยะเวลาที่ระงับบริการดังกล่าว
            และถือว่า
            ผู้ให้บริการไม่มีความรับผิดในการระงับบริการดังกล่าวไม่ว่าประการใด
            ซึ่งรวมถึงข้อบกพร่องที่ไม่สามารถคาดการณ์ได้ล่วงหน้า
            อันอาจจะเกิดจุดบกพร่องของอุปกรณ์ ซอฟต์แวร์
            หรือสิ่งอื่นใดที่มีผลกระทบต่อการใช้บริการและให้บริการ
          </p>
          <p>18. ผู้ให้บริการ ข้อแจ้งให้ทราบและเข้าใจ ดังนี้</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.1
            ไม่รับผิดชอบต่อความเสียหายใดๆก็ตามที่เกิดจากการใช้บริการ
            หรือเกิดจากความบกพร่องของผู้ใช้บริการ
            ทั้งนี้หากผู้ใช้บริการจำเป็นต้องชดใช้ค่าเสียหาย
            ผู้ให้บริการจำกัดความรับผิดต่อค่าเสียหายที่แท้จริงที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อมสูงสุดไม่เกิน
            1,000 บาท หรือตามที่ผู้ให้บริการเห็นสมควร
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.2
            หากความเสียใดๆก็ตามที่ผู้ใช้บริการกระทำการ หรือจงใจกระทำการ
            หรือพยายามกระทำการไม่ว่าจะโดยตรงหรือโดยอ้อม
            อันจะทำให้ผู้ให้บริการได้รับความเสียหาย เสียชื่อเสียง หรือสิ่งใด
            ผู้ให้บริการมีสิทธิเรียกร้องค่าเสียหาย
            หรือฟ้องร้องดำเนินคดีตามกฎหมายได้
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.3
            ข้อกำหนด ข้อตกลง สัญญา หรือข้อความใดในเงื่อนไขการใช้บริการนี้
            หากเป็นโมฆะหรือโมฆียะให้เป็นไปตามกฎหมายของไทยเท่านั้น
            ทั้งนี้ให้ยกเว้นส่วนที่ไม่ได้เป็นโมฆะหรือโมฆียะให้ใช้บังคับต่อไป
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.4
            กรณีที่ข้อความใดๆมีความขัดหรือแย้งกัน
            ในฉบับภาษาไทยและฉบับแปลภาษาอื่นๆ
            ให้ถือตามฉบับภาษาไทยมีผลเหนือฉบับแปลภาษาอื่นๆ
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.5
            การกระทำใดๆก็ตามที่มีผลต่อการใช้บริการของผู้ให้บริการและผู้ใช้บริการ
            ให้อยู่ภายใต้การบังคับของกฎหมายไทยเท่านั้น
            โดยไม่คำนึงสถานที่ตั้งของระบบ ข้อมูล และการใช้งาน
            รวมถึงกฎหรือบทบัญญัติว่าด้วยการเลือกกฎหมายหรือการขัดกันของกฎหมาย
            และให้ศาลในราชอาณาจักรไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาชี้ขาดตัดสินข้อพิพาทที่เกิดขึ้นภายใต้
            ข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว
          </p>
          <p>
            19. ผู้ให้บริการสามารถเปลี่ยนแปลง ข้อตกลง เงื่อนไขการใช้บริการ
            นโยบายความเป็นส่วนตัว ข้อกำหนด สัญญา
            และหรือชื่ออื่นใดอันมีความหมายเช่นเดียวกัน
            ในการให้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
            และไม่มีความรับผิดใดๆต่อคู่สัญญาและบุคคลภายนอก
          </p>
          <p>
            20.
            หากตรวจสอบแล้วพบว่ามีการระบุน้ำหนักไม่ถูกต้องทางบริษัทสามารถเรียกเก็บเงินส่วนต่างภายหลังได้ตามจริง
          </p>
          <p>
            21.
            ผู้ใช้บริการต้องเข้าใจและยอมรับข้อตกลงและเงื่อนไขต่างๆของผู้ให้บริการที่ได้มีการเปลี่ยนแปลงแล้ว
            หากผู้ใช้บริการเข้าใช้บริการหลังมีการเปลี่ยนแปลง
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>{' '}
      <h2>นโยบายคุ้มครองความเป็นส่วนตัว (Privacy Policy)</h2>
      <div class="article-page text-left">
        <div class="article-wrapper">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การคุ้มครองความเป็นส่วนตัวและข้อมูลส่วนบุคคลบนเว็บไซต์ในเครือข่ายของบริษัท
            ชิปป๊อป จำกัด ซึ่งในที่นี่จะเรียกว่า เว็บไซต์ SHIPPOP
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SHIPPOP
            ให้ความสำคัญในการคุ้มครองความเป็นส่วนตัวและข้อมูลส่วนบุคคลอย่างยิ่ง
            จึงจัดทำ นโยบายคุ้มครองความเป็นส่วนตัว
            เพื่อเป็นแนวทางปฏิบัติในการจัดการข้อมูลส่วนบุคคล (Personal
            Information) ของผู้ใช้บริการ ที่ติดต่อเข้ามายังเว็บไซต์ SHIPPOP
            ดังนั้น
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ทั้งนี้
            การติดต่อเข้ามายังเว็บไซต์หรือเข้าใช้บริการของ SHIPPOP
            ไม่ว่าจะด้วยวิธีการใด ให้
            ถือว่าท่านยินยอมผูกพันตามนโยบายฉบับนี้ทุกประการ
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>การเก็บข้อมูลส่วนบุคคล</strong>
          </p>
          <p>
            1. SHIPPOP เป็นผู้ให้บริการรวบรวมบริษัทขนส่ง มาไว้ในระบบเดียว
            ง่ายต่อการเชื่อมต่อและเลือกใช้บริการที่หลากหลายด้วยความรวดเร็วและปลอดภัย
            ทางเว็บไซต์ SHIPPOP มีความจำเป็นต้องจัดเก็บรวบรวมข้อมูลส่วนบุคคล
            เช่น เช่น อีเมลแอดเดรส (Email Address) ชื่อ (Name) ที่อยู่
            หรือที่ทำงาน (Home or Work Address) เขตไปรษณีย์ (ZIP Code)
            หรือหมายเลขโทรศัพท์ (Telephone Number) เป็นต้น
          </p>
          <p>
            2. ในกรณีที่ท่านสมัคร (Sign Up) เพื่อสมัครสมาชิก
            หรือเพื่อใช้บริการอย่างใดอย่างหนึ่ง เว็บไซต์ SHIPPOP
            จะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพิ่มเติมได้แก่ เพศ (Sex) อายุ
            (Gender) สิ่งที่โปรดปราน/ความชอบ (Preferences/Favorites) ความสนใจ
            (Interests) หรือ หมายเลขบัตรเครดิต (Credit Card Number)
            และที่อยู่ในการแจ้งค่าใช้จ่าย (Billing Address)
          </p>
          <p>
            3. นอกจากนั้นเพื่อสำรวจความนิยมในการใช้บริการ
            อันจะเป็นประโยชน์ในการนำสถิติไปใช้ในการปรับปรุงคุณภาพในการให้บริการของ
            เว็บไซต์ SHIPPOP
            จึงจำเป็นต้องจัดเก็บรวบรวมข้อมูลของท่านบางอย่างเพิ่มเติมได้แก่
            หมายเลขไอพี (IP Address) ชนิดของโปรแกรมค้นผ่าน (Browser Type)
            โดเมนเนม (Domain Name) บันทึกหน้าเว็บ (web page)
            ของเว็บไซต์ที่ผู้ใช้เยี่ยมชม เวลาที่เยี่ยมชมเว็บไซต์ (Access Times)
            และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น (Referring Website
            Addresses)
          </p>
          <p>
            เว็บไซต์ SHIPPOP
            ขอแนะนำให้ท่านตรวจสอบนโยบายการคุ้มครองข้อมูลส่วนบุคคล (Privacy
            Policy) ของเว็บไซต์อื่นที่เชื่อมโยงจากเว็บไซต์นี้
            เพื่อจะได้ทราบและเข้าใจว่าเว็บไซต์ดังกล่าว เก็บ รวบรวมใช้
            หรือดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านอย่างไร ทั้งนี้ เว็บไซต์
            SHIPPOP ไม่สามารถรับรองข้อความ หรือรับรองการดำเนินการใดๆ
            ตามที่ได้มีการ ประกาศไว้ในเว็บไซต์ดังกล่าวได้ และไม่ขอรับผิดชอบใดๆ
            หากเว็บไซต์เหล่านั้นไม่ได้ปฏิบัติการ หรือดำเนินการใดๆ
            ตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่เว็บไซต์ดังกล่าวได้ประกาศไว้
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>การใช้ข้อมูลส่วนบุคคล</strong>
          </p>
          <p>
            1. เว็บไซต์ SHIPPOP จะใช้ข้อมูลส่วนบุคคลของท่านเพียงเท่าที่จำเป็น
            เช่น ชื่อและที่อยู่ เพื่อใช้ในการติดต่อให้บริการ ประชาสัมพันธ์
            หรือให้ข้อมูลข่าวสารต่างๆ
            รวมทั้งสำรวจความคิดเห็นของท่านในกิจการหรือกิจกรรมของ สรอ. เท่านั้น
          </p>
          <p>
            2. เว็บไซต์ SHIPPOP ขอแจ้งให้ทราบว่า ข้อมูลต่างๆ ที่ผู้ใช้บริการ
            หรือผู้เข้าสู่ระบบ หรือผู้ทำรายการ ไม่ว่าจะด้วยวิธีการก็ตาม
            ได้นำข้อมูลเข้าสู่ระบบทางคอมพิวเตอร์
            จะมีสิทธิ์ในการใช้ข้อมูลต่างๆเหล่านั้นแต่เพียงผู้เดียว
          </p>
          <p>
            3. ในกรณี เว็บไซต์ SHIPPOP ได้ว่าจ้างหน่วยงานอื่น
            เพื่อให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่าน เช่น
            การจัดส่งพัสดุไปรษณีย์ การวิเคราะห์เชิงสถิติในกิจการ หรือกิจกรรมของ
            เว็บไซต์ SHIPPOP เป็นต้น เว็บไซต์ SHIPPOP
            จะกำหนดให้หน่วยงานที่ได้ว่าจ้างให้ดำเนินการดังกล่าวเก็บรักษาความลับ
            และความปลอดภัยของข้อมูลส่วนบุคคลของท่าน
            และกำหนดข้อห้ามมิให้มีการนำข้อมูลส่วนบุคคลดังกล่าวไปใช้นอกเหนือจากกิจกรรมหรือกิจการของ
            เว็บไซต์ SHIPPOP
          </p>
          <p>
            4. ทั้งนี้
            การใช้งานข้อมูลส่วนบุคคลของท่านให้เป็นไปตามเงื่อนไขการใช้บริการ
            และนโยบายคุ้มครองความเป็นส่วนตัวนี้
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>สิทธิในการควบคุมข้อมูลส่วนบุคคลของท่าน</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวของท่าน
            ท่านมีสิทธิเลือกที่จะให้มีการใช้หรือแชร์ข้อมูลส่วนบุคคลของท่าน
            หรืออาจเลือกที่จะไม่รับข้อมูล หรือสื่อทางการตลาดใดๆ จาก เว็บไซต์
            SHIPPOP ก็ได้ นโยบายคุ้มครองความเป็นส่วนตัว ก็ได้
            โดยเพียงแต่ท่านกรอกความจำนงดังกล่าวเพื่อแจ้งให้ เว็บไซต์ SHIPPOP
            ทราบ
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>การรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคล</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน
            เว็บไซต์ SHIPPOP
            จึงได้กำหนดระเบียบภายในหน่วยงานเพื่อกำหนดสิทธิในการเข้าถึง
            หรือใช้ข้อมูลส่วนบุคคลของท่าน และเพื่อรักษาความลับ
            และความปลอดภัยของข้อมูลบางอย่าง ที่มีความสำคัญอย่างยิ่ง เช่น
            หมายเลขบัตรเครดิต เป็นต้น เว็บไซต์ SHIPPOP
            จึงได้จัดให้มีช่องทางการสื่อสารแบบปลอดภัย
            สำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว เช่น
            จัดให้มีการใช้ Secure Socket Layer (SSL) protocol เป็นต้น
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>การใช้คุกกี้ (Cookies)</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&ldquo;คุกกี้&rdquo;
            คือ ข้อมูลที่ เว็บไซต์ SHIPPOP ส่งไปยังโปรแกรมค้นผ่านเว็บไซต์ (Web
            browser) ของผู้ใช้บริการ
            และเมื่อมีการติดตั้งข้อมูลดังกล่าวไว้ในระบบของท่านแล้ว หากมีการใช้
            &ldquo;คุกกี้&rdquo; ก็จะทำให้เว็บไซต์ของ สรอ.
            สามารถบันทึกหรือจดจำข้อมูลของผู้ใช้บริการไว้จนกว่าผู้ใช้บริการจะออกจากโปรแกรมค้นผ่านเว็บไซต์
            หรือจนกว่าผู้ใช้บริการจะทำการลบ &ldquo;คุกกี้&rdquo; นั้นเสีย
            หรือไม่อนุญาตให้ &ldquo;คุกกี้&rdquo; นั้นทำงานอีกต่อไป
            หากท่านเลือกใช้ &ldquo;คุกกี้&rdquo;
            แล้วท่านจะได้รับความสะดวกสบายในการท่องเว็บไซต์มากขึ้น เพราะ
            &ldquo;คุกกี้&rdquo; จะช่วยจดจำเว็บไซต์ที่ท่านแวะหรือเยี่ยมชมทั้งนี้
            สรอ. จะนำข้อมูลที่ &ldquo;คุกกี้&rdquo; ได้บันทึกหรือเก็บรวบรวมไว้
            ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในกิจกรรมอื่นของ เว็บไซต์ SHIPPOP
            เพื่อปรับปรุงคุณภาพการให้บริการของ เว็บไซต์ SHIPPOP ต่อไป
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>การปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เว็บไซต์
            SHIPPOP
            อาจทำการปรับปรุงหรือแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคลโดยมิได้แจ้งให้ท่านทราบล่วงหน้า
            ทั้งนี้เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนั้น
            เว็บไซต์ SHIPPOP
            จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายการคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่เยี่ยมชมหรือมีการใช้บริการจากเว็บไซต์ของ
            เว็บไซต์ SHIPPOP
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในกรณีที่ท่านมีข้อสงสัย
            ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคล
            หรือการปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ เว็บไซต์
            SHIPPOP ยินดีที่จะตอบข้อสงสัยรับฟังข้อเสนอแนะ
            และคำติชมทั้งหลายอันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของ
            เว็บไซต์ SHIPPOP ต่อไป โดยท่านสามารถติดต่อกับ เว็บไซต์ SHIPPOP
            ตามที่อยู่ที่ปรากฏบนเว็บไซต์
          </p>
          <p>&nbsp;</p>
        </div>
      </div>{' '}
    </div>
  </section>
)

const termsAndPrivacyEngXML = (
  <section>
    <div class="wrapper-1000 wrapper-terms-privacy">
      <h2>Terms of Use</h2>
      <div class="article-page text-left">
        <div class="article-wrapper">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We
            partner up with logistic companies combine in to a single system ,
            easy to connect and got various choice for customer to choose what
            best for them especially for the e-commerce business please read the
            following term carefully to get the benefits from our service.
          </p>
          <p>&nbsp;</p>
          <p>
            1. This term of use by Shippop company has the purpose to declare
            rights and regulation for customer to understand and comply
          </p>
          <p>2. Definition</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1
            &ldquo;service provider&rdquo; mean SHIPPOP company or in the source
            of www.shippop.com
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.2
            &ldquo;users&rdquo; mean any person that want to use our product or
            service from the &ldquo;service provider&rdquo;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3
            &ldquo;term of use &ldquo; mean rule and regulation that
            &ldquo;service provider&rdquo; inform &ldquo;user&rdquo;
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.4
            &ldquo;service&rdquo; mean we provide all the logistic firm into one
            single system
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.5
            &ldquo;data&rdquo; mean any information that are provide by the
            &ldquo;users&rdquo; to the &ldquo;service provider&rdquo; for them
            to provide a better service
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.6
            &ldquo;confidential data&rdquo; mean information that both parties
            provide to each other. Whether verbally in writing or electronics
            industries. It does not include any information that already release
            to public
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.7
            &ldquo;service charge&rdquo; mean the service charge that user are
            agreed to pay to the service provider
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.8
            &ldquo;agency&rdquo; mean a person or company that are authorize by
            SHIPPOP company to use their service for business.
          </p>
          <p>
            3. Customer need to understand and agree with laws and regulation
            before registered to our website and use our service
          </p>
          <p>
            4. Getting access to our website mean that users accept and fully
            understand the rules and regulation of the service provider
          </p>
          <p>5. SHIPPOP will not transport the following goods</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.1
            live animal
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.2
            drugs
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.3
            pornography or banned sign
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.4
            flammable product
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.5
            sharp object without protected envelope
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.6
            hazardous goods
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.7
            good that are prohibited by local regulations or require special
            authorization
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5.8
            good that contrary to public morality , defamatory or undermine the
            stability of religion and monarchy of the Thai nation
          </p>
          <p>
            6. customer need to provide a full statement data to the SHIPPOP
            company for us to provide a better service for customer , the
            company might ask for some more data in the future to improve our
            service.
          </p>
          <p>
            7. Import or Export data from the website that might harm our system
            hardware or software shall be governed by the laws of the kingdom of
            Thailand
          </p>
          <p>
            8. customer should not intervene or try to harm SHIPPOP computer
            system and network shall be governed by the laws of the kingdom of
            Thailand
          </p>
          <p>
            9. customer can't let other parties use their membership to make
            order. If the third parties cause damage or loss of interest to you
            the company will not be responsible in any way
          </p>
          <p>
            10. customer can't transfer their membership to another parties
            absolutely
          </p>
          <p>
            11. SHIPPOP will record, store and process data provided by the
            customer to provide it service, SHIPPOP will make it best effort to
            ensure confidentially of such data. However
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.1 if
            the customer compliant
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.2
            authorities lawfully request such data
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 11.3
            private policy regulation
          </p>
          <p>
            12. Plagiarism or adapting the system from our company will be
            governed by the law of the kingdom of Thailand
          </p>
          <p>
            13. service provider can use any information that the user provide
            to the service provider through SHIPPOP to research and analyze,
            discrimination or anywhere else. As appropriate without prior
            notice. Has to be data that are consent by the user first
          </p>
          <p>
            14. service provider reserve the right to restore the service in the
            event that the user want to cancel the service or cut down the
            service before the end of the contract. the user have no right to
            recall the service charge in any circumstance except the service
            provider found it reasonable to restore or not, if there is a
            violation in the agreement service provider have right to notify
            users and terminated the contract if there isn&rsquo;t any
            improvement. and if the action affect the network or reputation of
            the company. Users are solely responsible for all damages that occur
          </p>
          <p>
            15. &ldquo;service provider&rdquo; has the right to terminated the
            user contract accordingly even though the user hasn't violate in the
            agreement. &ldquo;service provider&rdquo; will return service charge
            according to what the user haven&rsquo;t use and user cant recall
            anything else except what they have pay for our service.
          </p>
          <p>
            16. SHIPPOP company have the right to terminated contact with the
            customer that hasn't been using the system for a long time without
            any advance notice
          </p>
          <p>
            17. &ldquo;Service providers&rdquo; may suspend service temporarily.
            Because of certain necessary And in the event of a suspension of the
            surcharge. We reserve the right to not refund the fee for the period
            of suspension of the service provider and assumes no liability to
            withhold such services, whether any. This includes defects that can
            not be predicted in advance. This may be due to a bug in the
            software of the device or other things that affect the use and
            serve.
          </p>
          <p>18. Please read the following notice</p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.1
            our liability is limited to the actual value of shipment lost or
            damage, but not exceed a maximum of 1,000 baht per each shipment
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.2 If
            the customer try to cause damange or loss of interest to the company
            whether directly or indirectly to the company shall be governed by
            the law of the kingdom of Thailand
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.3
            Any covenant, agreement, contact or message in terms of accessing
            the service, whether it is void or voidable following the law of
            Thailand only. However the section that are not void or voidable are
            continue to enforce
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.4 if
            there is any conflict or contradict each other in paper term whether
            its in Thai translation or other language, the company will take the
            thai translation as the main contact above others
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 18.5
            any action that affects the use of the service provider and service
            user will be governed by the law of the kingdom of Thailand
          </p>
          <p>
            19. SHIPPOP company have the right to change or adapt privacy
            policy, rules and regulation or any circumstances about out service
            without any notice and with no liability to the partner or the third
            parties.
          </p>
          <p>
            20. If the weight are incorrected, SHIPPOP will charged the
            difference later.
          </p>
          <p>
            21. customer need to understand and accept rules and regulation that
            has been changed even if the customer join after we changed
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>{' '}
      <h2>Privacy Policy</h2>
      <div class="article-page text-left">
        <div class="article-wrapper">
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The
            following statement is to declare our private policy to our customer
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SHIPPOP
            has been given full attention to protect customer private
            information so we came up with these private policy to guide
            customer how to manage their personal information for the user that
            came to contact with our website
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Although
            the contact can be in any source of way SHIPPOP will hold on to this
            policy as always
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Data storage</strong>
          </p>
          <p>
            1. SHIPPOP is a service provider which we conclude all the logistic
            firm in to one system which is easy for customer to connect ,
            SHIPPOP website have a necessary term to gather private information
            such as Email, Name address or workplace, zip code and telephone
            number
          </p>
          <p>
            2. For the case that customer want to be a membership our website
            would like to gather some more information from customer such as Sex
            , Gender , Preferences , interest, credit card number and billing
            address
          </p>
          <p>
            3. In order to survey and improve our service system our company
            would like to gather some more private information such as IP
            address, Browser type, Domain name, web page, Access time and
            Referring website address
          </p>
          <p>
            SHIPPOP company would like to urge our customer to learn and
            understand our private policy Although our company won&rsquo;t take
            any responsibility to the action that are outside our policy in any
            circumstances
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Uses of personal information</strong>
          </p>
          <p>
            1. SHIPPOP website will use your personal information just what it
            needed such as name, address to contact our service, newsletter or
            even your opinion about our service
          </p>
          <p>
            2. SHIPPOP website would like to inform you that the information
            provided by the users. Whether its a login data Or the transaction
            data that user provide in the system No matter how. SHIPPOP has the
            right to use such information solely.
          </p>
          <p>
            3. If our site SHIPPOP hired another agency. To proceed with your
            personal information, such as parcel delivery. Statistical Analysis
            in Business The activities of such sites or sites SHIPPOP. SHIPPOP
            will grant the agency has hired to carry out such confidentiality.
            And the security of your personal information. And the restrictions
            to such personal information to outside activities or activities of
            the site SHIPPOP.
          </p>
          <p>
            4. The use of your personal information in accordance with the Terms
            of Service. And this Privacy Policy.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Right to control your personal information</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;For our
            customer benefit to protect their private information, you have a
            choice whether to share your information online or not.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Security for personal information</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;For our
            customer benefit to keep their information confidential, our website
            has create rules and regulation in order to use our service or to
            use their personal information such as credit card number, our
            website have create a safe communication channel. for the personal
            information we have encoded the information such as SSL protocol.
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Cookies</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cookies
            is the information our website use to send through Web browser of
            the user and when user connect to the system and use cookies will
            automatically be store in the EGA website
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EGA will
            use these information to analyze statically of the event user uses
            to make improve our service to be better for our customer
          </p>
          <p>&nbsp;</p>
          <p>
            <strong>Change in private policy</strong>
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SHIPPOP
            company have right to change or adapt privacy policy, rules and
            regulation or any circumstances about our service without any notice
            although this is a case that we will improve for a better service
            solution. We urges our customer to read and understand the
            regulation everytime the user uses our website
          </p>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Incase
            customer have any question or guideline that wanted to share to us
            customer are most welcome to contact us through our website address.
          </p>
          <p>&nbsp;</p>
        </div>
      </div>{' '}
    </div>
  </section>
)

const TermsAndPrivacyPage = () => {
  const classes = useStyles()
  const Router = useRouter()
  const isEnglish = Router.locale === 'en'

  const [isAccepted, setAccepted] = useState(false)
  const [isShowingForm, setShowingForm] = useState(false)
  const [userData, setUserData] = useState(null)

  const { displaySnackBar, renderSnackBar } = useSnackBar()
  const { t } = useTranslation('terms-and-privacy')

  useEffect(() => {
    if (!Router.isReady) return
    const email = Router.query.email
    const key = Router.query.token
    if (email && key && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      setShowingForm(true)
      setUserData({
        email: email,
        key: key,
      })
    }
  }, [Router.isReady])

  const handleConfirm = () => {
    Axios.post('/api/auth/accept-terms', { email: userData.email, key: userData.key })
      .then(res => {
        displaySnackBar('success', t('confirm-success'))
      })
      .catch(err => {
        const message = err.response?.data?.message
        switch (message) {
          case 'token not found':
            displaySnackBar('error', t('token-not-found'))
            break
          case 'invalid token':
            displaySnackBar('error', t('token-not-found'))
            break
          case 'email mismatch token':
            displaySnackBar('error', t('token-not-match'))
            break
          case 'token expired':
            displaySnackBar('error', t('token-expired'))
            break
          case 'internal error':
            displaySnackBar('error', t('internal-error'))
            break
          default:
            displaySnackBar('error', t('internal-error'))
        }
      })
  }

  return (
    <div className={classes.root}>
      <Layout>
        <div className={classes.page}>
          <Container>
            <Paper elevation={3} className={classes.paper}>
              {isEnglish ? termsAndPrivacyEngXML : termsAndPrivacyXML}
            </Paper>
            {isShowingForm && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                padding={2}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAccepted}
                      onChange={(e) => setAccepted(e.target.checked)}
                      name="accept"
                      color="primary"
                    />
                  }
                  label={t('accept-terms')}
                />
                <ButtonSp
                  className={classes.button}
                  disabled={!isAccepted}
                  onClick={handleConfirm}
                >
                  {t('confirm')}
                </ButtonSp>
              </Box>
            )}
            {renderSnackBar()}
          </Container>
        </div>
      </Layout>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'terms-and-privacy',
    ])),
  },
})

export default TermsAndPrivacyPage
